// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3SPma","content":"LayoutSettings_content__1vlKF"};